/**
 * Homepage media (V26). Everything lives in the public `site-assets` bucket on Supabase Storage under
 * `homepage/`, uploaded with scripts/upload-site-asset.mjs (one-year cache header). The video is the
 * handoff's team background transcoded to 1080p (4.7 MB) and 720p (2.0 MB); the photos are the prototype's
 * embedded images resized to 1800px. Nothing here is bundled, so the JS stays small and previews share prod's CDN.
 */
const BASE = 'https://tboltfobncbjwjelavsl.supabase.co/storage/v1/object/public/site-assets/homepage'

export const HOMEPAGE_ASSETS = {
  logo: `${BASE}/love-and-photos-logo.svg`,
  hero: `${BASE}/hero.jpg`,
  approach: `${BASE}/approach.jpg`,
  reviewPhoto: `${BASE}/review-photo.jpg`,
  // About page (Trera, 21 Sep 2026): a videographer's camera trained on a ceremony. Supplied as a 490x734 screenshot.
  aboutPhoto: `${BASE}/../about/videographer-ceremony.jpg`,
  gallery: [
    { src: `${BASE}/gallery-1.jpg`, alt: 'Bride and groom beneath a floral wedding arch' },
    { src: `${BASE}/gallery-2.jpg`, alt: 'Bride and groom portrait' },
    { src: `${BASE}/gallery-3.jpg`, alt: 'Wedding party celebrating' }
  ],
  teamVideo: {
    poster: `${BASE}/team-background-poster.jpg`,
    mp4_1080: `${BASE}/team-background-1080.mp4`,
    mp4_720: `${BASE}/team-background-720.mp4`
  }
}
